import styled from 'styled-components';


export const StyledOfficeMap = styled.div` 
  min-height: 350px;
  height: 100%;

  .office-map-container {
    top: -1px;
    min-height: 350px;
    height: 100%;
    padding: 0px;
    position: relative;
  }
`;



// WEBPACK FOOTER //
// ./src/components/OfficeMap/styles/StyledOfficeMap.js